import React from 'react';

import {
  CategoriesCardContainer,
  CategoriesCardOverlay
} from './CategoriesCard.styles';

const CategoriesCard = ({ details }) => {
  const { title, id, imageURL } = details;
  return (
    <CategoriesCardContainer to={`/category/${id}`}>
      <img
        src={require(`../../assets/img/${imageURL}`)}
        alt={`${title} background`}
        width="400"
        height="300"
      />
      <CategoriesCardOverlay>
        <h2>{title}</h2>
      </CategoriesCardOverlay>
    </CategoriesCardContainer>
  );
};

export default CategoriesCard;
